import React from 'react';
import { Dropdown as AntDropdown, DropDownProps as AntDropdownProps } from 'antd';
import { createUseStyles } from 'react-jss';
import { ThemeType } from 'src/theming/jssTypes';

export interface DropdownProps extends AntDropdownProps {}

const useStyles = createUseStyles((theme: ThemeType) => ({
  dropdown: {
    '& .ant-dropdown-menu': {
      backgroundColor: theme.color.semantic.background.neutral.subtle,
      padding: theme.spacing[1],
      borderRadius: theme.radius.sm,
      boxShadow: theme.shadow.md,
    },
    '& .ant-dropdown-menu-item': {
      color: theme.color.semantic.text.primary,
      fontSize: `${theme.typography.fontSize.sm} !important`,
      '&:hover': {
        backgroundColor: theme.color.semantic.background.neutral.soft,
      },
      '&:active, &:focus': {
        backgroundColor: theme.color.semantic.background.neutral.soft,
      },
      '&.ant-dropdown-menu-item-disabled': {
        color: theme.color.semantic.text.subtle,
        cursor: 'not-allowed',
      },
    },
    '& .ant-dropdown-menu-submenu-title': {
      color: theme.color.semantic.text.primary,
      fontSize: `${theme.typography.fontSize.sm} !important`,
      '&:hover': {
        backgroundColor: theme.color.semantic.background.neutral.soft,
      },
    },
  },
}));

const Dropdown: React.FC<DropdownProps> = ({ overlayClassName = '', ...rest }) => {
  const classes = useStyles();
  return (
    <AntDropdown
      {...rest}
      overlayClassName={`${classes.dropdown} ${overlayClassName}`.trim()}
    />
  );
};

export default Dropdown;
